//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  inject: ["main"]
};